import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, Signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { parseISO } from 'date-fns';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Pop } from 'src/app/classes/shared/pop';
import { Project } from 'src/app/interfaces/api/project';
import { User } from 'src/app/interfaces/api/user';
import { EventService } from 'src/app/services/api/events/event.service';
import { ProjectService } from 'src/app/services/api/projects/project.service';
import { ZoneService } from 'src/app/services/api/zones/zone.service';
import { AuthService } from 'src/app/services/core/auth.service';
import { RangePickerComponent } from 'ui-library';

@Component({
  selector: 'app-create-event-dialog',
  templateUrl: './create-event-dialog.component.html',
  styleUrls: ['./create-event-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatButtonModule,
    TranslateModule,
    RangePickerComponent
  ]
})
export class CreateEventDialogComponent implements OnInit {
  // Services
  public readonly dialogRef: MatDialogRef<CreateEventDialogComponent> = inject(MatDialogRef<CreateEventDialogComponent>);
  readonly data: any = inject(MAT_DIALOG_DATA);
  private readonly auth: AuthService = inject(AuthService);
  private readonly eventService: EventService = inject(EventService);
  private readonly pop: Pop = inject(Pop);
  private readonly translate: TranslateService = inject(TranslateService);
  private readonly zoneService: ZoneService = inject(ZoneService);
  private readonly projectService: ProjectService = inject(ProjectService);

  // Variables
  event: any = {};
  currentImage: any;
  public photos: any[] = [];
  errorPhotos = false;
  zones: any[] = [];
  storedEvents: any[] = [];
  destroy$ = new Subject<void>();

  // Signals
  readonly user: Signal<User> = this.auth.currentUser;
  readonly project: Signal<Project> = this.projectService.currentProjectSignal;

  constructor() {
    this.translate.get("home").pipe(takeUntil(this.destroy$)).subscribe();
  }

  ngOnInit() {
    this.getListZones();
    this.event.startDate = parseISO(this.data.startDate).toISOString();
    this.event.endDate = parseISO(this.data.endDate).toISOString();
  }

  dismiss(): void {
    this.data.dismissed = true
    this.dialogRef.close();
  }

  ok(): void {
    this.dialogRef.close({ event: this.event });
  }

  onPickerChanged(data: any) {
    this.event.startDate = parseISO(data.startDate).toISOString();
    this.event.endDate = parseISO(data.endDate).toISOString();
  }

  saveEvent() {
    this.event.startDate = parseISO(this.event.startDate).toISOString();
    this.event.endDate = parseISO(this.event.endDate).toISOString()

    if (!this.event.title || this.event.startDate > this.event.endDate) return;

    this.event.user = this.user().id;
    this.event.project = this.project().id;
    this.event.trackerName = this.user().email;
    this.event.type = "Generated event";

    this.eventService.addEvent(this.event).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.ok();
        this.pop.toast(this.translate.instant('events.event_created'), 'success', 4000, 'add');
      },
      error: (e) => {
        console.error(e);
      }
    })
  }

  takePicture() {
    // this.camera.getPicture(this.options).then((imageData) => {
    //   this.photos.unshift({
    //     data: 'data:image/jpeg;base64,' + imageData
    //   });
    // }, (err) => {
    //   console.error(err)
    // });
  }

  getListZones() {
    this.zoneService.getZones().pipe(takeUntil(this.destroy$)).subscribe(zones => this.zones = zones)
  }
}
